(ns minorodata.connections.sources.webgains
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "webgains"
   :enabled      true
   :name         "Webgains"
   :description  "The hi-performance affiliate marketing network"
   :image-source "webgains-logo-2.png"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
              (fn [data]
                (let [{:keys [name description username password]} data]
                  {:source-type "webgains"
                   :name        name
                   :description description

                   :source
                                {:credentials         {:username  username
                                                       :password  password}}}))

    :format-for-inputs
              (fn [data]
                (let [{:keys [source name description]} data
                      {:keys [credentials]} source]
                  (merge
                    (select-keys credentials [:username :password])
                    {:name              name
                     :description       description})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :webgains-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Username"
              :required   true
              :name       :username
              :value      ""}
             {:block-type :input
              :label      "Password"
              :required   true
              :name       :password
              :type       :password
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
              (fn [{:keys [name description status action destination-table
                           report campaign-id extract-type start-date end-date]}]
                {:name          name
                 :description   description
                 :status        status
                 :output-tables [destination-table]

                 :config
                 {:extracts [{:report            report
                              :campaign-id       campaign-id
                              :extract-type      extract-type
                              :start-date        start-date
                              :end-date          end-date
                              :destination-table destination-table
                              :action            action}]}})

    :format-for-inputs
              (fn [data]
                (let [{:extract/keys [name description status config]} data

                      extract (get-in config [:extracts 0])]
                  (merge
                    (select-keys extract [:report :action :start-date :end-date :campaign-id :extract-type :destination-table])
                    (app.utils/keep-non-nil-keys
                      {:name          name
                       :description   description
                       :status        status}))))

    :validate (constantly nil)

    :id :webgains-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :input
              :label      "Campaign ID"
              :name       :campaign-id
              :required   true
              :value      ""}


             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Endpoint Service"
              :name       :report
              :options    [{:name "Full Earnings with LockDate"       :value "full-earnings-with-lock-date"}
                           {:name "Programmes With Membership Status" :value "get-programmes-with-membership-status"}]
              :required   true
              :value      "full-earnings-with-lock-date"}

             {:block-type :select
              :label      "Extract type"
              :name       :extract-type
              :options    [{:name "Incremental" :value "incremental"}
                           {:name "Full"        :value "backfill"}]
              :required   true
              :value      ""
              :conditions [[:eq [:report :value] "full-earnings-with-lock-date"]]}

             {:block-type :date-picker
              :label "From"
              :name :start-date
              :required false
              :conditions [[:and [[:extract-type :value] [:report :value]] ["backfill" "full-earnings-with-lock-date"]]]}

             {:block-type :date-picker
              :label "To"
              :name :end-date
              :required false
              :conditions [[:and [[:extract-type :value] [:report :value]] ["backfill" "full-earnings-with-lock-date"]]]}


             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "backfill"]]]}

             {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
